import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpService} from "../../services/http.service";
import {PreloaderService} from "../../services/preloader.service";
import {Response} from "@angular/http";
import {LockService} from "../../services/lock.service";
import {NvFileUploader} from "../../classes/nv-file-uploader/nv-file-uploader.class";
import {FileLikeObject} from "ng2-file-upload";
import {BusService} from "../../services/bus.service";


@Component({
  selector: 'app-textures-page',
  templateUrl: './textures-page.component.html',
  styles: []
})
export class TexturesPageComponent implements OnInit, OnDestroy {
  private _intervalId;
  private _running: boolean = true;
  private _hasBaseDropZoneOver:boolean = false;

  get PACKER_STATE_INTERVAL(): number { return 5000 };
  get running() { return this._running; }
  get hasBaseDropZoneOver() { return this._hasBaseDropZoneOver; }


  uploader = new NvFileUploader({
    url: "/animations/upload-zip",
    removeAfterUpload: true,
    queueLimit: 10,
    filters: [{ name: "filename-filter", fn: (file:FileLikeObject): boolean => {
      return /\.zip$/.test(file ? file.name: "");
    }}]
  });


  constructor(private httpService: HttpService,
              private preloaderService: PreloaderService,
              private busService: BusService) {
  }


  onUploadAllClick() {
    this.uploader.uploadAll();
    this.preloaderService.show();
  }


  onClearQueueClick() {
    this.uploader.clearQueue()
  }


  ngOnInit() {
    this.busService
      .onTexturePackerIsBusy
      .subscribe((isBusy:boolean):void => this.setPackerState(isBusy));


    this.getPackerState();
    this._intervalId = setInterval(() => this.getPackerState(), this.PACKER_STATE_INTERVAL);
  }


  ngOnDestroy(): void {
    clearInterval(this._intervalId);
  }


  onRunTexturePackerClick() {
    this.preloaderService.show();
    this.httpService.post("/animations/run-packer")
      .subscribe(():void => {
        this.preloaderService.hide();
      });
  }


  fileOverBase(e:any):void {
    this._hasBaseDropZoneOver = e;
  }


  private setPackerState(isBusy:boolean):void {
    this._running = isBusy;
  }


  private getPackerState() {
    // todo: use socket instead of http !!!
    this.httpService
      .load("/animations/get-state")
      .subscribe((r:Response): void => {
        try {
          this.setPackerState(r.json().running);
        } catch (e) {
          this.setPackerState(true);
        }
      })
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/home/textures-page.component.ts